import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import MainWrapper from '@views/Records/Common/MainWrapper';
import Main from '@views/Timeline/Main';

const messages = defineMessages({
  title: {
    id: 'timelineMain.title',
    defaultMessage: 'My Health Timeline',
  },
});

export default function TimelinePage() {
  const { formatMessage } = useIntl();

  return (
    <MainWrapper
      backgroundIcon="logo"
      friendlyName={formatMessage(messages.title)}
      showBreadcrumb={false}
      showHeader
      title={formatMessage(messages.title)}
    >
      <Main />
    </MainWrapper>
  );
}
